import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import BasicTextFields from './BasicTextFields';
import ClientProvider from './client';
export default createDemo(import.meta.url, BasicTextFields, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/text-fields/demos/basic/BasicTextFields.tsx",
    "fileName": "BasicTextFields.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Box from '@mui/material/Box';\nimport TextField from '@mui/material/TextField';\n\nexport default function BasicTextFields() {\n  return (\n    <Box\n      component=\"form\"\n      sx={{ '& > :not(style)': { m: 1, width: '25ch' } }}\n      noValidate\n      autoComplete=\"off\"\n    >\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <TextField id=\"outlined-basic\" label=\"Outlined\" variant=\"outlined\" />\n      <TextField id=\"filled-basic\" label=\"Filled\" variant=\"filled\" />\n      <TextField id=\"standard-basic\" label=\"Standard\" variant=\"standard\" />\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Box>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 17,
        "focusedLines": 3,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Box from '@mui/material/Box';\nimport TextField from '@mui/material/TextField';\n\nexport default function BasicTextFields() {\n  return (\n    <Box\n      component=\"form\"\n      sx={{ '& > :not(style)': { m: 1, width: '25ch' } }}\n      noValidate\n      autoComplete=\"off\"\n    >\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <TextField id=\"outlined-basic\" label=\"Outlined\" variant=\"outlined\" />\n      <TextField id=\"filled-basic\" label=\"Filled\" variant=\"filled\" />\n      <TextField id=\"standard-basic\" label=\"Standard\" variant=\"standard\" />\n"
      ],
      [
        "span",
        "frame",
        "    </Box>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 12
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "TextField"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "id"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "outlined-basic",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "label"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Outlined",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "variant"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "outlined",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 13
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "TextField"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "id"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "filled-basic",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "label"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Filled",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "variant"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "filled",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 14
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "TextField"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "id"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "standard-basic",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "label"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Standard",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "variant"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "standard",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 17,
    "focusedLines": 3,
    "collapsible": true,
    "externals": [
      "@mui/material/Box",
      "@mui/material/TextField"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
